export class SocketChannel {
  constructor() {
    /** @type {Record<string, { handle: Function }>} */
    this._handlers = {}
  }

  /**
   * @param {string} event
   * @param {{ handle(data: any, context: any): Promise<void> | void }} handler
   */
  register(event, handler) {
    if (typeof handler?.handle !== 'function') {
      throw new Error(`[WS] Handler for event "${event}" must implement .handle(data, context)`)
    }
    this._handlers[event] = handler
  }

  /**
   * Вызывается при приходе события от WebSocket
   * @param {any} context - Nuxt контекст, store, $nuxt, router и т.п.
   * @param {{ event: string }} data
   */
  async process(context, data) {
    if (!data?.event) data.event = 'unnamed'
    const handler = this._handlers[data?.event]
    if (!handler) {
      console.warn(`[WS] Unknown event "${data?.event}"`)
      return
    }

    try {
      await handler.handle(data, context)
    }
    catch (err) {
      console.error(`[WS] Error in handler for event "${data.event}":`, err)
      context.$sentry.captureException(err)
    }
  }
}
